<template>
  <div ref="fileTableWrapper" :class="`file-table-wrapper ${className}`" :style="width ? { width } : ''">
    <el-button
      v-if="onRecommendReport"
      type="primary"
      round
      size="mini"
      style="position:absolute;top:5px;left:245px"
      @click="onRecommendReport"
      >推荐报告</el-button
    >
    <el-table
      ref="table"
      v-loading="loading"
      :data="list"
      :height="tableHeight"
      highlight-current-row
      class="flex-column"
      size="mini"
      border
      :resizable="false"
      :row-class-name="tableRowClassName"
    >
      <el-table-column type="index" align="center" width="50" />
      <el-table-column width="60" label="操作" align="center">
        <template slot-scope="scope">
          <div class="flex-row item-center">
            <el-button v-if="isDownloadShow(scope.row)" type="text" size="mini" @click="download(scope.row)"
              >下载</el-button
            >
          </div>
        </template>
      </el-table-column>
      <el-table-column label="文件名（点击预览）" min-width="160">
        <template slot-scope="scope">
          <div class="name">
            <a @click="preview(scope.row)"
              >{{ scope.row['文件名'] || scope.row.originalname }} {{ scope.row.originalid ? '（已混淆）' : '' }}</a
            >
          </div>
        </template>
      </el-table-column>
      <el-table-column v-if="showRecommend" label="简历评分" width="100">
        <template slot-scope="scope">
          <div style="text-align:center;">
            <el-button type="text" size="mini" @click="evaluate(scope.row)"
              >{{ (scope.row.简历评分 && scope.row.简历评分.总评分) || '查看详细' }}
              <i v-if="scope.row.简历评分" class="el-icon-search el-icon--right"></i>
            </el-button>
          </div>
        </template>
      </el-table-column>
      <el-table-column v-if="showRecommend" label="建议职能模块" width="150">
        <template slot-scope="scope">
          <div v-if="scope.row.简历打分 && scope.row.简历打分.建议职能模块">
            <template v-for="(c, k) in scope.row.简历打分.建议职能模块">
              <span v-if="c == '置信度不够' || c == '没有解析内容'" :key="k + 't'">{{ c }}</span>
              <span
                v-else
                :key="k + 't'"
                class="a-tag"
                style="cursor:pointer"
                @click="showReason({ md5: scope.row.md5, cate: c })"
                >{{ c }}</span
              >
            </template>
          </div>
          <div
            v-else-if="
              (scope.row.type == 'cv' || scope.row.type == '原始简历' || scope.row.type == '推荐报告') &&
                scope.row.error_message
            "
          >
            <span class="a-link" @click="reLabelPredict(scope.row)">点击重新预测</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column v-if="showRecommend" label="建议行业" width="120">
        <template slot-scope="scope">{{
          scope.row.简历打分 && scope.row.简历打分.建议行业 && scope.row.简历打分.建议行业.toString()
        }}</template>
      </el-table-column>
      <el-table-column v-if="showRecommend" label="预测结果解释" width="120">
        <template slot-scope="scope">
          <div style="text-align:center;">
            <el-button type="text" size="mini" @click="showReason_v2({ md5: scope.row.md5, row: scope.row })"
              >查看</el-button
            >
          </div>
        </template>
      </el-table-column>

      <el-table-column label="类型" width="80">
        <template slot-scope="scope">
          <div class="file-type" :title="scope.row.labeledType || scope.row.type" @click="editType(scope, 'type')">
            {{ scope.row.labeledType || scope.row.type }} <i v-if="scope.row.md5" class="el-icon-edit ft-blue"></i>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="上传人" width="120">
        <template slot-scope="scope">{{ scope.row.uploader && scope.row.uploader.toString() }}</template>
      </el-table-column>
      <el-table-column label="时间" width="120">
        <template slot-scope="scope">{{ moment(scope.row.createdAt) }}</template>
      </el-table-column>
      <el-table-column v-if="onDelete" label="删除" min-width="50">
        <template v-if="checkOwner(scope.row)" slot-scope="scope">
          <a class="ft-danger" @click="onDelete(scope.row)">删除</a>
        </template>
      </el-table-column>
      <el-table-column v-if="onMark" label="非该人选附件" min-width="95">
        <template v-if="scope.row.uploader === '系统'" slot-scope="scope">
          <a class="ft-danger" @click="onMark(scope.row)">{{ scope.row.isWrong ? '取消解绑' : '解绑' }}</a>
        </template>
      </el-table-column>
      <el-table-column label="详情" align="center">
        <template slot-scope="scope">
          <a
            v-if="scope.row.listOption && scope.row.listOption.fileList && scope.row.listOption.fileList.length > 0"
            @click="showFileList(scope.row.listOption.fileList)"
            >详情</a
          >
          <span v-else>--</span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      v-if="paginate"
      :current-page="page"
      :page-sizes="[100, 200, 500]"
      :page-size="pageSize"
      :total="total"
      background
      layout="total, sizes, prev, pager, next, jumper"
      @size-change="pageSizeChange"
      @current-change="pageChange"
    />
    <el-dialog
      :modal="false"
      :title="`修改文件${target.label}`"
      :close-on-click-modal="false"
      :visible.sync="editVisible"
      @close="saveModified"
    >
      <div v-if="target.row" class="flex-row item-center">
        <div class="dialog-input-fieldname">{{ target.label }}</div>
        <el-autocomplete v-model="target.row[target.fieldname]" :fetch-suggestions="querySearch" size="mini" />
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="fileListDialogVisible"
      :modal="false"
      :close-on-click-modal="false"
      custom-class="custom-dialog"
    >
      <div slot="title" class="title">
        <div class="title-name">list文件详情</div>
        <div class="side-title"></div>
        <div class="handle-btn"></div>
      </div>
      <div style="height: 500px;overflow-y: scroll;">
        <el-table :data="fileList" border size="mini">
          <el-table-column label="文件名">
            <template slot-scope="scope">
              <a class="mr5" @click="preview(scope.row)">{{ scope.row.originalname || '--' }}</a>
            </template>
          </el-table-column>
          <el-table-column width="160" label="操作" align="center">
            <template slot-scope="scope">
              <a
                v-if="showDownload && (isAdmin || scope.row.type == '推荐报告') && userInservice"
                @click="download(scope.row)"
                >下载</a
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
    <label_desc ref="label_desc"></label_desc>
    <CvGrade ref="CvGrade"></CvGrade>
  </div>
</template>

<script>
import { download, preview } from '../../../project/src/constant/utils'
import { fileTypes } from '../../../project/src/constant/type'
import label_desc from './LabelDesc'
import CvGrade from '../../../misc/src/components/CvGrade'

const dateFormat = require('dateformat')

export default {
  components: {
    label_desc,
    CvGrade,
  },
  props: {
    files: { type: Array, default: undefined },
    showConfuse: { type: Boolean, default: false },
    showDownload: { type: Boolean, default: true },
    showRecommend: { type: Boolean, default: false },
    paginate: { type: Boolean, default: true },
    query: { type: Object, default: undefined },
    fetchMethod: { type: Function, default: undefined },
    height: { type: [String, Number], default: undefined },
    width: { type: [String, Number], default: undefined },
    className: { type: String, default: '' },
    projectId: { type: String, default: '' },
    onDelete: { type: Function, default: undefined },
    onMark: { type: Function, default: undefined },
    onRecommendReport: { type: Function, default: undefined },
    rid: { type: String, default: undefined },
  },
  data() {
    return {
      list: [],
      page: 1,
      pageSize: 100,
      total: 0,
      dialogVisible: false,
      loading: false,
      tableHeight: undefined,
      target: {},
      editVisible: false,
      iframe_src: null,
      // 是否在职，在职true
      userInservice: true,
      fileList: [],
      fileListDialogVisible: false,
    }
  },
  computed: {
    download() {
      return download
    },
    preview() {
      return preview
    },
    isAdmin() {
      return app.user.角色 && app.user.角色.includes('管理员')
    },
  },
  watch: {
    files: {
      handler(val, oldVal) {
        if (val) {
          const valCopy = JSON.parse(JSON.stringify(val))
          this.list = valCopy.sort((a, b) => {
            const atime = a.updatedAt || a.createdAt || 0
            const btime = b.updatedAt || b.createdAt || 0
            return !btime || atime > btime ? -1 : 1
          })
          // this.list = valCopy.sort((a, b) => (!b.updatedAt || a.createdAt > b.createdAt ? -1 : 1))
        }
      },
      immediate: true,
    },
    projectId: {
      handler(val, oldVal) {
        !this.files && this.getFiles()
      },
      immediate: true,
    },
    height: {
      handler(val, oldVal) {
        if (val) {
          this.tableHeight = val
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.userInservice = !['离职中', '已离职'].includes(app.user.状态)
    if (!this.tableHeight) {
      const el = this.$refs.fileTableWrapper
      if (el && el.scrollHeight > 100) {
        this.tableHeight = el.scrollHeight - 40
      }
    }
  },
  methods: {
    async evaluate(file) {
      // if (!file.简历评分) {
      //   const result = await app.service('resumeEval').evaluateNew({ _id: file._id || file.md5 || file.fileId })
      //   if (result.status === 'success' && result.data) {
      //     this.showEvaluate(result.data)
      //   }
      // } else {
      //   this.showEvaluate(file)
      // }
      this.$refs.CvGrade.open(file)
    },
    showFileList(fileList) {
      this.fileListDialogVisible = true
      this.fileList = fileList
    },
    showEvaluate(file) {
      this.$msgbox({
        title: '简历评分详情',
        dangerouslyUseHTMLString: true,
        closeOnClickModal: false,
        closeOnPressEscape: false,
        showClose: false,
        message: `<p><strong>总评分:</strong>  ${file.简历评分.总评分}</p>
                      <p><strong>教育经历:</strong></p>
                      <p>&nbsp&nbsp毕业院校: ${file.简历评分.教育经历.毕业院校}</p>
                      <p>&nbsp&nbsp学位: ${file.简历评分.教育经历.学位}</p>
                      <p><strong>工作经历:</strong></p>
                      <p>&nbsp&nbsp公司平台: ${file.简历评分.工作经历.公司平台}</p>
                      <p>&nbsp&nbsp最近工作经历: ${file.简历评分.工作经历.最近工作经历}</p>
                      <p>&nbsp&nbsp稳定性: ${file.简历评分.工作经历.稳定性}</p>
                      <p>&nbsp&nbsp工作经验: ${file.简历评分.工作经历.工作经验}</p>
                      <p><strong>能力:</strong></p>
                      <p>&nbsp&nbsp性别: ${file.简历评分.能力.性别}</p>
                      <p>&nbsp&nbsp证书: ${file.简历评分.能力.证书}</p>`,
      })
    },
    async getFiles(params) {
      if (!this.fetchMethod) return
      this.loading = true
      const query = { query: this.query } || {}
      const param = Object.assign(
        query,
        {
          paginate: {
            page: this.page,
            pageSize: this.pageSize,
          },
        },
        params,
      )
      try {
        const { data, page, pageSize, total } = await this.fetchMethod(param)
        this.list = data
        this.page = page
        this.pageSize = pageSize
        this.total = total
      } catch (error) {
        this.$message.error(error.message)
      }
      this.loading = false
    },
    moment(date) {
      return date ? dateFormat(new Date(parseInt(date, 10)), 'yyyy-mm-dd') : '--'
    },
    async confuse(file) {
      try {
        await window.app.service('file').confuseXlsx(file)
        this.$message('操作成功')
      } catch (error) {
        this.$message.error(error.message)
      }
    },
    pageSizeChange(val) {
      this.getFiles({
        paginate: {
          page: 1,
          pageSize: val,
        },
      })
    },
    pageChange(val) {
      this.getFiles({
        paginate: {
          page: val,
        },
      })
    },
    checkOwner(file) {
      const user = window.app.user
      if (user['角色'] && user['角色'].includes('管理员')) return true
      if (typeof file.uploader === 'string') return user.account === file.uploader
      if (file.uploader instanceof Array) return file.uploader.includes(user.account)
    },
    editType(scope, fieldname) {
      const {
        row,
        column: { label },
      } = scope
      if (!row.md5) {
        this.$message.error('该条文件数据缺少md5，请联系管理员修复')
        return
      }
      this.target = Object.assign({}, { row, label, fieldname })
      this.editVisible = true
    },
    querySearch(queryString, cb) {
      const matches = queryString ? fileTypes.filter(type => type.indexOf(queryString) > -1) : fileTypes
      const results = matches.map(type => ({
        label: type,
        value: type,
      }))
      cb(results)
    },
    async saveModified() {
      const {
        row: { md5, type },
      } = this.target
      try {
        await app.service('project').modifyFileType({ md5, type })
      } catch (e) {
        this.$message.error((e.response && e.response.message) || e.message)
      }
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.isWrong) {
        return 'gray-row'
      }
      return ''
    },
    async showReason_v2({ md5, cate, row }) {
      // console.log(row._id)
      this.$refs.label_desc.show(row._id, null)
    },
    async showReason({ md5, cate, row }) {
      if (cate == '置信度不够' || cate == '没有解析内容') return false
      const res = await app.service('misc').getRecommendCateReason({ md5, cate })
      console.log(res)
      if (res.status == 'success') {
        const { data } = res
        let content = '暂无解释'
        if (Array.isArray(data) && data.length > 0) {
          content = `根据【${data[0].words.toString()}】关键词得出建议职能模块【${data[0].class}】`
        }
        this.$alert(content, '解释', {
          showCancelButton: false,
          showConfirmButton: false,
        })
          .then(() => {})
          .catch(() => {})
      }
    },
    async reLabelPredict(file) {
      const res = await app.service('file').labelPredict({ file })
      if (res.status == 'success') {
        this.list = this.list.map(l => {
          if (l.md5 == file.md5) {
            l = Object.assign(l, res.data)
          }
          return l
        })
      } else {
        this.$message.error(res.msg)
      }
    },
    isDownloadShow(row) {
      return (
        this.showDownload &&
        this.userInservice &&
        (this.isAdmin ||
          row.type == '推荐报告' ||
          (row.type == '会面记录' &&
            ((Array.isArray(row.uploader) && row.uploader.includes(app.user.account)) ||
              row.uploader == app.user.account)))
      )
    },
  },
}
</script>

<style scoped>
.name {
  display: block;
  text-align: center;
}
.file-type {
  cursor: pointer;
}
.file-type:hover .el-icon-edit {
  display: block;
}
.file-type .el-icon-edit {
  position: absolute;
  right: 0;
  top: 0;
  font-size: 16px;
  display: none;
}
.dialog-input {
  width: 100%;
  height: 24px;
  outline: 0;
  display: inline-block;
  -webkit-appearance: none;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  border: 0;
  padding: 0;
  font: inherit;
  margin: 0;
  background: transparent;
  line-height: 24px;
  font-size: inherit;
  resize: none;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  color: #000;
}
.dialog-input-fieldname {
  color: #909399;
  font-weight: bold;
  margin-right: 10px;
}
.dialog-input-field {
  position: relative;
  padding-top: 7px;
  padding-bottom: 7px;
}
.dialog-input-field:before {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  border: 1px hidden;
  border-bottom: 1px solid;
  background: transparent;
  pointer-events: none;
  content: '';
}
tr.gray-row > td,
tr.gray-row > td > .cell span,
tr.gray-row > td > .cell a {
  color: #ccc;
}
tr.gray-row > td > .cell a.ft-danger {
  color: #606266 !important;
}
</style>
